import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    templateUrl: "./roadmap-subpage.component.html",
    styleUrls: ["../shared.scss", "./roadmap-subpage.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoadmapSubpageComponent {}
